/*  global _ */
import {createPopper} from '@popperjs/core'
import maxSize from 'popper-max-size-modifier'

export default {
  name: 're-popper',
  props: {
    noClose: {
      type: [Boolean, Function],
      default() {
        return true
      }
    },
    reference: {},
    placement: {
      default: 'bottom' // top/bottom/right/left
    },
    strategy: {
      default: 'fixed', // absolute//fixed
    },
    modifiers: {
      default() {
        return []
      },
    },
    onFirstUpdate: {},
    containerClass: {
      type: [Array, String, Object, Function],
      default: ''
    },
    contentClass: {
      type: [Array, String, Object, Function],
      default: ''
    },
    // [using built-in modifiers]
    // true: Sets max height to fit inside the visible view
    autoLimitHeight: {
      default: true
    },
    // [using built-in modifiers]
    // offset from max height
    // applied when autoLimitHeight is set to true
    maxHeightOffset: {
      default: 5
    },
    // [using built-in modifiers]
    // additional styles added to popper container
    // style property names must be in camelCase
    popperStyles: {},
    // to disable built-in modifiers
    skipBuiltInModifiers: {
      default: false
    },
  },
  data() {
    return {
      popper: null,
    }
  },
  computed: {
    containerClasses() {
      return [
        this.containerClass,
      ]
    },
    contentClasses() {
      return [
        this.contentClass,
      ]
    },
    styleModifier() {
      if (this.skipBuiltInModifiers) {
        return []
      }
      const roundOffsets = {
        name: 'computeStyles',
        options: {
          roundOffsets: ({x, y}) => {
            return {
              x: Math.round(x),
              y: Math.round(y),
            }
          }
        }
      }
      const styleModifier = {
        name: "styleModifier",
        enabled: true,
        phase: "beforeWrite",
        requires: ["maxSize"],
        fn: ({state}) => {
          const {height} = state.modifiersData.maxSize
          if (this.autoLimitHeight) {
            const max = Math.floor(height - (this.maxHeightOffset || 0))
            state.styles.popper.maxHeight = `${max}px`
          }
          if (!_.isEmpty(this.popperStyles)) {
            _.forOwn(this.popperStyles, (value, key) => {
              state.styles.popper[key] = value
            })
          }
        }
      }
      return [roundOffsets, maxSize, styleModifier]
    },
  },
  mounted() {
    const ref = this.reference || this.$el.parentElement
    this.popper = createPopper(
      ref,
      this.$el,
      {
        placement: this.placement || 'bottom',
        modifiers: [...this.styleModifier, ...this.modifiers],
        strategy: this.strategy,
        onFirstUpdate: this.onFirstUpdate,
      }
    )
  },
  beforeDestroy() {
    this.popper.destroy()
  },
  methods: {
    dismiss() {
      this.$emit('close')
      this.$emit('dismiss')
    }
  }
}
